import {connect} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {getAllVerifyResponse} from "../store/logIn";
import Header from "../blocks/header";
import Dashboard from "../blocks/dashboard";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import Box from "@mui/material/Box";
import Copyright from "../blocks/copyright";
import {useTranslation} from "react-i18next";
import AdminFilter from "../blocks/AdminFilter";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import SearchIcon from "@mui/icons-material/Search";
import {toast} from "react-toastify";
import {getSectionReports, deleteSectionReport, messageReset} from "../store/sectionReports";
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
    FormControl, InputAdornment, InputLabel, OutlinedInput, Pagination} from "@mui/material";

const PAGE_SIZE = 20

const SECTION_LABELS = {
    biznes_reja:        'section_biznes_reja',
    kuzgi_qishki:       'section_kuzgi_qishki',
    mehnat_muhofazasi:  'section_mehnat_muhofazasi',
    yongin_xavfsizligi: 'section_yongin_xavfsizligi',
    inventarizatsiya:   'section_inventarizatsiya',
}

function Sections(props) {
    const is_main = JSON.parse(localStorage.getItem('is_main'))
    const navigate = useNavigate()
    const {t} = useTranslation()
    const params = useParams()
    const sectionType = params.sectionType
    const regionId = params.id || false
    const pageTitle = t(SECTION_LABELS[sectionType] || sectionType)

    const [searchCompany, setSearchCompany] = useState('')
    const [openDelete, setOpenDelete] = useState(false)
    const [deleteItem, setDeleteItem] = useState(null)
    const [page, setPage] = useState(1)
    const [adminRegionId, setAdminRegionId] = useState('')
    const [searchTimer, setSearchTimer] = useState(null)

    function fetchData(pg, sc) {
        const _rid = regionId || adminRegionId || ''
        const _sc  = sc !== undefined ? sc : searchCompany
        props.getSectionReports(sectionType, pg || page, PAGE_SIZE, _sc, _rid, '', '')
    }

    function handleAdminFilter({regionId: r}) {
        const rid = r || ''
        setAdminRegionId(rid); setPage(1)
        props.getSectionReports(sectionType, 1, PAGE_SIZE, searchCompany, rid, '', '')
    }

    useEffect(() => { fetchData(1, '') }, [sectionType])

    useEffect(() => {
        if (searchTimer) clearTimeout(searchTimer)
        const timer = setTimeout(() => { setPage(1); fetchData(1, searchCompany) }, 400)
        setSearchTimer(timer)
    }, [searchCompany])

    useEffect(() => {
        if (props.verify === false) navigate("/login/")
    }, [props.verify])

    useEffect(() => {
        if (props.message === 'deleted') {
            toast.success(t('delete_success'), {theme: 'colored'})
            props.messageReset(); fetchData()
        } else if (props.message === 'error') {
            toast.error(t('save_error'), {theme: 'colored'}); props.messageReset()
        }
    }, [props.message])

    function handlePageChange(e, value) {
        setPage(value); fetchData(value)
        window.scrollTo({top: 0, behavior: 'smooth'})
    }

    function getFullDateTime(val) {
        if (!val) return '-'
        const d = new Date(val)
        const p = n => String(n).padStart(2, '0')
        return `${p(d.getDate())}.${p(d.getMonth()+1)}.${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`
    }

    function handleDeleteConfirm() {
        if (deleteItem) props.deleteSectionReport(deleteItem)
        setOpenDelete(false); setDeleteItem(null)
    }

    const items = props.sectionReports || []

    return <div>
        <div className={'page worker-page'}>
            <Header/><Dashboard/>
            <Box component="main" sx={{flexGrow:1, height:'100vh', overflow:'auto'}}>
                <Toolbar/>
                <div className={'main'}>
                    <Button variant="outlined" startIcon={<ChevronLeftIcon/>} onClick={() => navigate(-1)}>{t('back')}</Button>
                    <div className={'header-page'}>
                        <h2 className={'page-title'}>{pageTitle}</h2>
                        {!is_main && (
                            <Button variant="contained" endIcon={<AddIcon/>}
                                    onClick={() => navigate(`/add-section/${sectionType}/`)}>
                                {t('add')}
                            </Button>
                        )}
                    </div>

                    {is_main && !regionId && (
                        <div style={{marginBottom:'16px'}}>
                            <FormControl variant="outlined" style={{minWidth:300}}>
                                <InputLabel htmlFor="search-section">{t('search_company')}</InputLabel>
                                <OutlinedInput id="search-section" value={searchCompany}
                                               onChange={(e) => setSearchCompany(e.target.value)}
                                               endAdornment={<InputAdornment position="end"><SearchIcon/></InputAdornment>}
                                               label={t('search_company')}/>
                            </FormControl>
                        </div>
                    )}

                    {is_main && !regionId && <AdminFilter onFilter={handleAdminFilter}/>}

                    {items.length ? (
                        <table className="table table-hover table-responsive">
                            <thead><tr>
                                <th>#</th>
                                {is_main && <th>{t('title_company')}</th>}
                                <th>{t('section_text_label')}</th>
                                <th>{t('download')}</th>
                                {is_main && <th>{t('section_sent_time')}</th>}
                                <th/>
                            </tr></thead>
                            <tbody>
                            {items.map((item, index) => (
                                <tr key={item.id}>
                                    <th>{(page-1)*PAGE_SIZE+index+1}</th>
                                    {is_main && <td>{item.user?.user_name || 'ADMIN'}</td>}
                                    <td style={{maxWidth:'300px', wordBreak:'break-word'}}>
                                        {item.text ? (item.text.length > 80 ? item.text.substring(0,80)+'...' : item.text) : '-'}
                                    </td>
                                    <td><a href={item.file} target={'_blank'} rel="noreferrer"><DownloadIcon/></a></td>
                                    {is_main && <td style={{whiteSpace:'nowrap'}}>{getFullDateTime(item.created_time)}</td>}
                                    <td>
                                        <Button variant="contained" color="error" endIcon={<DeleteIcon/>}
                                                onClick={() => { setDeleteItem(item); setOpenDelete(true) }}/>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    ) : <div className={'no-infos'}>{t('no_info')}</div>}

                    {props.total_pages > 1 && (
                        <div style={{display:'flex', justifyContent:'center', padding:'20px 0'}}>
                            <Pagination count={props.total_pages} page={page} onChange={handlePageChange}
                                        color="primary" shape="rounded"/>
                        </div>
                    )}
                </div>
                <Copyright/>
            </Box>
        </div>

        <Dialog open={openDelete} onClose={() => setOpenDelete(false)}>
            <DialogTitle>{t('delete_title')}</DialogTitle>
            <DialogContent><DialogContentText>{t('delete_desc')}</DialogContentText></DialogContent>
            <DialogActions>
                <Button onClick={() => setOpenDelete(false)} variant="contained">{t('cancel')}</Button>
                <Button onClick={handleDeleteConfirm} variant="contained" color="error">{t('delete')}</Button>
            </DialogActions>
        </Dialog>
    </div>
}

export default connect(props => props.sectionReport, {
    getSectionReports, deleteSectionReport, getAllVerifyResponse, messageReset
})(Sections)
